"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DuplicationTypeToJSON = exports.DuplicationTypeFromJSONTyped = exports.DuplicationTypeFromJSON = exports.DuplicationType = void 0;
/**
 * Type of duplication to execute.
 * @export
 */
exports.DuplicationType = {
    SetOnly: 'AD_SET_ONLY',
    SetWithAds: 'AD_SET_WITH_ADS',
    Only: 'AD_ONLY'
};
function DuplicationTypeFromJSON(json) {
    return DuplicationTypeFromJSONTyped(json, false);
}
exports.DuplicationTypeFromJSON = DuplicationTypeFromJSON;
function DuplicationTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.DuplicationTypeFromJSONTyped = DuplicationTypeFromJSONTyped;
function DuplicationTypeToJSON(value) {
    return value;
}
exports.DuplicationTypeToJSON = DuplicationTypeToJSON;
